<div class="booked-vehicle-card">

<!-- vehicle -->
<div *ngIf="vehicleSearch">
  <div class="row">
    <div class="col-lg-3 col-md-4 col-4">
        <div class="car-image">
         <img class="img-fluid" [src]="bookedVehicle.vehicleImage" [alt]="bookedVehicle.vehicleName"  (click)="onVehicleImageClicked(vehicle)" >
        </div>
       <div class="car-colors d-flex justify-content-center">
         <ul>
          <li class="d-inline" *ngFor="let color of bookedVehicle.vehicleColors">
            <div class="color-box mr-1" [style.backgroundColor]="color" ></div>
          </li>
         </ul>
       </div>
       <div class="car-details d-flex justify-content-between">
       <div class="car-rank mr-auto"><span class="badge badge-pill badge-primary"><!--{{bookedVehicle.vehicleRankNumber}}-->7.8</span> <!--{{bookedVehicle.vehicleRankText}}--> Good</div>  
       <div class="car-reviews"><button class="btnLink"  (click)="openDialog()">({{bookedVehicle.vehicleTotalReviews}}) {{ 'Reviews' | translate }}</button></div> 
       </div>
      </div>
    <div class="col-lg-6  col-md-8 col-8 border-right">
      <div class="d-flex">        
       <div class="vehicle-name mr-auto">
          {{bookedVehicle.vehicleName}}
        </div>   
        <!-- <div class="vehicle-top-list  d-flex align-items-top">
         <fa-icon class="mr-1 grey"   matTooltip="{{ 'TotalRental' | translate }}" matTooltipPosition="above" [icon]="faKey"></fa-icon><span>({{bookedVehicle.vehicleRentalNumber}})</span>
        </div> -->
      </div>

      <div class="vehicle-class">
        {{bookedVehicle.vehicleClass}} 
      </div>   

      
      <div class="vehicle-features">
        <div class="row mt-2">
          <!-- vehicle Gear Type-->
          <div class="col-md-4  col-4 d-flex  align-items-top">       
            <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{bookedVehicle.vehicleGearType}}</li>
              </ul>
            </div>
        </div>

        <!-- vehicle Condition Unit -->
        <div class="col-md-4  col-4 d-flex align-items-top">
         <span><mat-icon   matTooltip="{{ 'ACUnit' | translate }}" matTooltipPosition="above" class="fa-s mr-1">ac_unit</mat-icon></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.hasAirConditions?'Yes':'No'}}</li>
            </ul>
          </div>
        </div>

        <!-- vehicle Petrol Type -->
        <div class="col-md-4 col-4  d-flex align-items-top">
         <span><fa-icon class="mr-1"  matTooltip="{{ 'FuelType' | translate }}" matTooltipPosition="above" [icon]="faGasPump"></fa-icon></span>
            <div>
              <ul  class="vehicle-inner-list">
                <li>{{bookedVehicle.vehiclePetrolType}}</li>
              </ul>
            </div>
        </div>  

        <!-- vehicle Passengers Number -->
        <div class="col-md-4  col-4 d-flex align-items-top">
         <span> <fa-icon class="mr-1"  matTooltip="{{ 'Passengers' | translate }}" matTooltipPosition="above" [icon]="faUser"></fa-icon></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.vehiclePassengersNumber}}</li>
            </ul>
          </div>
        </div>

        <!-- vehicle Doors Number -->
        <div class="col-md-4  col-4 d-flex align-items-top">
         <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.vehicleDoorsNumber}}</li>
            </ul>
          </div>
        </div>

        <!-- vehicle Storage -->
        <div class="col-md-4  col-4 d-flex align-items-top">
         <span><mat-icon  matTooltip="{{ 'Luggage' | translate }}" matTooltipPosition="above" class="fa-s luggage mr-1">luggage</mat-icon></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.vehicleStorage}}</li>
            </ul>
          </div>
        </div>

        <!-- vehicle Number -->
        <div class="col-md-4  col-4 d-flex align-items-top">
         <span><fa-icon  matTooltip="{{ 'PlateNumber' | translate }}" matTooltipPosition="above" class="mr-1 vehicleNumber" [icon]="faCar"></fa-icon></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.plateNumber}}</li>
            </ul>
          </div>
        </div>
            
        <!-- vehicle Odometer -->
        <div class="col-md-4 col-4 d-flex align-items-top">
         <span><fa-icon  matTooltip="{{ 'Odometer' | translate }}"   matTooltipPosition="above" class="mr-1 faRoad" [icon]="faRoad"></fa-icon></span>
          <div>
            <ul  class="vehicle-inner-list">
              <li>{{bookedVehicle.vehicleOdometer}}</li>
            </ul>
          </div>
        </div>
          
        </div>
        <div class="row mb-2 mt-2">
          <div class="col-md-12 location-line d-flex align-items-top"><fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{bookedVehicle.vehicleLocation}}</div>
        </div>
        <div *ngIf="bookedVehicle.hasPromotion;">
          <div class="promotion-box  mb-3">
            <div class="promotion-icon d-flex align-items-center"><fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{bookedVehicle.vehiclePromotionName}}:</div>
            <ul class="mb-0">
              <li *ngFor="let promotion of bookedVehicle.vehiclePromotions">{{promotion}}</li>
            </ul>
          </div>
        </div>
        <div class="d-inline car-icons">
          <fa-icon  [matTooltip]="bookedVehicle.vehicleDeposit" matTooltipPosition="above" [icon]="faDollarSign"></fa-icon>
          <fa-icon  matTooltip="Unlimited Mileage" matTooltipPosition="above"  [icon]="faRoad"></fa-icon>
          <fa-icon  matTooltip="Like To Like" matTooltipPosition="above"  [icon]="faBatteryHalf"></fa-icon>
          <fa-icon  matTooltip="Free Cancelation" matTooltipPosition="above"  [icon]="faBan"></fa-icon>
        </div>
        
      </div>
    </div>
    <div class="price justify-content-center d-flex align-items-center col-lg-3 col-md-12 col-12">
      <div class="justify-content-center">
        <div class="price-container">
         <div class="duration mb-2"> {{ 'PriceFor' | translate }} {{bookedVehicle.durationUnitName}}</div>
          <div class="vehicle-price mb-2">{{bookedVehicle.vehiclePrice | number}}{{currency}} </div>
          <div class="payable-now">
            {{ 'Paid' | translate }}
            <div class="">40%</div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
<!-- vehicle -->



</div>



